import $ from 'jquery';

let EndOfMovie = require('./end_of_movie');
window.$ = window.jQuery = require("jquery");

(function() {
    var _backstretch;

    _backstretch = $.fn.backstretch;

    $.fn.backstretch = function() {
        _backstretch.apply(this, arguments);
        return $(this).css("zIndex", "1");
    };

    $.pageChange = function(handler) {
        return $(document).ready(handler);
    };

    $.fn.exists = function() {
        return $(this).size() > 0;
    };

    $.pageChange(function() {
        return $("body").on("click", "a.top-text", function(e) {
            e.preventDefault();
            return $(window).animate({
                "scroll-top": 0
            }, "fast");
        });
    });

}).call(this);

(function() {
    (function() {
        var lsi, mobileOs, mouseEnter, mouseExit, stringToNum, timeout, _decode;
        mobileOs = /iphone|ipad|ipod|android/.test(navigator.userAgent.toLowerCase());
        lsi = window.lsi || (window.lsi = {});
        _decode = decodeURIComponent;
        stringToNum = function(text) {
            var val;
            val = parseFloat(text);
            if (isNaN(val)) {
                return 0;
            } else {
                return val;
            }
        };
        lsi.timeToText = function(time) {
            var minutes, seconds, text;
            time = Math.floor(time);
            minutes = Math.floor(time / 60);
            seconds = Math.round(time - (minutes * 60));
            text = "";
            if (minutes > 0) {
                text += minutes + "m";
            }
            if (seconds > 0) {
                text += seconds + "s";
            }
            return text;
        };
        lsi.textToTime = function(text) {
            var time, val;
            time = 0;
            if (/^[\d.]+$/.test(text)) {
                val = parseInt(text);
                if (isNaN(val)) {
                    return 0;
                } else {
                    return val;
                }
            }
            text.toLowerCase().replace(/([\d.]+?)([ms])/g, function(match, $1, $2) {
                var num;
                num = stringToNum($1);
                switch ($2) {
                    case "m":
                        time += num * 60;
                        break;
                    case "s":
                        time += num;
                }
                return "";
            });
            time -= 3;
            if (time < 0) {
                time = 0;
            }
            return Math.round(time);
        };
        lsi.getQueryObject = function() {
            var key, pair, query, search, val, _i, _len, _ref, _ref1;
            search = location.search;
            query = {};
            if (!(search.length > 0)) {
                return query;
            }
            search = search.substring(1, search.length);
            _ref = search.split("&");
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                pair = _ref[_i];
                _ref1 = pair.split("="), key = _ref1[0], val = _ref1[1];
                key = _decode(key);
                val = _decode(val);
                query[key] = val;
            }
            return query;
        };
        if (!mobileOs) {
            timeout = null;
            mouseEnter = function() {
                return $(this).stop().animate({
                    opacity: 1
                }, "fast");
            };
            mouseExit = function() {
                var fn;
                clearTimeout(timeout);
                fn = (function(_this) {
                    return function() {
                        return $(_this).stop().animate({
                            opacity: 0
                        }, "slow");
                    };
                })(this);
                return timeout = setTimeout(fn, 400);
            };
            return $.pageChange(function() {
                $("body").mousemove(function() {
                    var fn;
                    $(".back-to-browse").stop().animate({
                        opacity: 1
                    }, 100);
                    clearTimeout(timeout);
                    fn = (function(_this) {
                        return function() {
                            return $(".back-to-browse").stop().animate({
                                opacity: 0
                            }, "slow");
                        };
                    })(this);
                    return timeout = setTimeout(fn, 1400);
                });
                return $(".back-to-browse").animate({
                    opacity: 0
                }, "slow");
            });
        }
    })();

}).call(this);

$(document).ready(function (){
    EndOfMovie.initialize();
});
